import { Box } from '@mui/material';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

export const AdminTabLink = ({ to, label, icon: Icon }) => (
  <NavLink
    to={to}
    style={({ isActive }) => ({
      textDecoration: 'none',
      color: isActive ? '#fff' : '#555',
      background: isActive ? '#5965A6' : '#EEF2FF',
      border: '1px solid rgba(79,172,254,0.2)',
      padding: '7px 12px',
      borderRadius: 999,
      fontSize: 13,
      fontWeight: 600,
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
    })}
  >
    <Icon style={{ fontSize: 18 }} />
    {label}
  </NavLink>
);

AdminTabLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
};

export const AdminTabs = ({ items }) => (
  <Box sx={{ display: 'flex', gap: 1, py: 2 }}>
    {items.map((it) => (
      <AdminTabLink key={it.to} {...it} />
    ))}
  </Box>
);

AdminTabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.elementType.isRequired,
    }),
  ).isRequired,
};
